import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/admin/useCsatAdminQueryKeys.ts
var t = e("admin-csat", {
	summary: (e) => ["summary", e],
	timeseries: (e, t) => [
		"timeseries",
		e,
		t
	],
	reasons: (e, t) => [
		"reasons",
		e,
		t
	],
	responses: (e) => ["responses", e]
});
//#endregion
export { t as csatAdminQueryKeys };
